import "../ui/tabs";

$(".js-form-subscription").validate({
    errorPlacement: function (error, element) {
        if (element.attr("type").match("checkbox")) {
            error.insertAfter(element.siblings("label"));
        } else {
            error.insertAfter(element);
        }
    },
    submitHandler: function (form) {
        const $form = $(form);
        const $submit = $(form).find(".js-newsletter-submit");

        $submit.prop("disabled", true).addClass("is-loading");

        if ($submit[0]._tippy) {
            $submit[0]._tippy.hide();
        }

        $.post(
            $form.attr("action"),
            $form.serialize(),
            function (data) {
                var msg = data.msg.format;

                if (!msg) {
                    msg = data.msg;
                }

                if (data.status) {
                    $(".js-newsletter-email").val("").trigger("change");
                    $(".js-subscription-consents")
                        .find('input[type="checkbox"]')
                        .prop("checked", false);

                    requestAnimationFrame(() => {
                        $form.validate().resetForm();
                    });
                }

                Eshop.tippyAlert(
                    $submit[0],
                    msg,
                    {
                        theme: data.status ? "success" : "error",
                    },
                    15 * 1000
                );
            },
            "json"
        )
            .fail(function (response) {
                let msg = $form.data("general-error");

                if (response.status == 403) {
                    msg = $form.data("captcha-error");
                }

                Eshop.tippyAlert(
                    $submit[0],
                    msg,
                    {
                        theme: "error",
                    },
                    20 * 1000
                );
            })
            .always(function () {
                $submit.prop("disabled", false).removeClass("is-loading");
                rEvent.dispatch("Recaptcha.execute");
            });

        return false;
    },
});
